import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { config, awsconfig } from './config'
import { Amplify } from 'aws-amplify'
import App from './App';

Amplify.configure({
  Auth: {
    mandatorySignIn: false,
    region: config.REGION || 'eu-west-2',
    userPoolId: config.USER_POOL_ID || 'eu-west-2_PRIGOxaq7',
    userPoolWebClientId: config.APP_CLIENT_ID || '2ts0jom54p7994l3sif7biab85',
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    signInConfig: {
      isSignUpDisplayed: false
    }
  },
  ...awsconfig
})



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
